<template>
  <div class="p-3">
    <h4 class="header-title mt-0 mb-1">{{ $t('industry.form.information') }}</h4>
    <p class="sub-header"></p>

    <div class="row">

      <div class="col-md-12">
        <TextField 
          :placeholder="$t('industry.form.name.label')"
          :label="$t('industry.form.name.label')"
          v-model="model.name"
        />
      </div>

    </div>
  </div>
</template>

<script>
import  FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  mixins: [ FormMixin ],
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      model: {}
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  computed: {
    industryID() {
      let parameters = this.parameters || {}
      return parameters.industryID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    }
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.industryID
      
      return this.$store.dispatch('industry/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    industryID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.industryID) {
      this.fetchData()
    }
  }
}
</script>